// extracted by mini-css-extract-plugin
export var productImage = "_rq-1";
export var viewLink = "_rq-2";
export var wishlistItem = "_rq-0";